// extracted by mini-css-extract-plugin
export var label = "_90-1";
export var reminder = "_90-0";